import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from "antd";
import { CustomMainContent, DropDownFilterDates } from '../../../components'
import CardProgressParesa from '../../../components/common/NewUi/CardProgressParesa'
import Meanings from '../../../components/common/NewUi/Meanings'
import { onGetAllAlumsByGroups } from '../../../api'
import { Dropdown, Space } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { CarBarCharParesa } from '../../../components/common/NewUi/CarBarCharParesa';
const baseNamesEstructure = {
                LP01_EPP_EquipodeProteccionPersonal:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
        numberOdSteaps: 7,
                },
                LP01_LOTO_Despaletizadora:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 11,
                },
                LP01_LOTO_Paletizadora:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 11,
                },
                LP01_SAM_PaletizadorayDespaletizadora:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 6,
                },
                LP03_EPP_EquipodeProteccionPersonal:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 7,
                },
                LP03_LOTO_RinserLlenadorayCapsulador:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 12,
                },
                LP03_SAM_RinserLlenadorayCapsulador:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 6,
                },
                LP06_02_EPP_EquipodeProteccionPersonal:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 7,
                },
                LP06_02_LOTO_Envolvedor:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 16,
                },
                LP06_02_LOTO_PaletizadoraMagazindePallets:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 12,
                },
                LP06_02_SAM_Envolvedor:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 12,
                },
                LP06_02_SAM_PaletizadoraMagazindePallets:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 7,
                },
                LP06_EPP_EquipodeProteccionPersonal:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 7,
                },
                LP06_LOTO_MixerRinserLlenadorayCapsulador:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 24,
                },
                LP06_SAM_MixerRinserLlenadorayCapsulador:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 9,
                },
                LP07_EPP_EquipodeProteccionPersonal:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 7,
                },
                LP07_LOTO_LlenadoraySopladora:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 12,
                },
                LP07_SAM_LlenadoraySopladora:{
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                    numberOdSteaps: 10,
                },
            } 

export const LearningDashboardParesa = () => {
    const [moduleSelected, setmoduleSelected] = useState(1)
    const [dataTratated, setdataTratated] = useState(baseNamesEstructure)
    const [usersAndProgress, setUsersAndProgress] = useState({
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        finishedUsers: 0,
    })
    const [infoModules, setinfoModules] = useState({
        "LP01_EPP_EquipodeProteccionPersonal": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP01_LOTO_Despaletizadora": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP01_LOTO_Paletizadora": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP01_SAM_PaletizadorayDespaletizadora": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP03_EPP_EquipodeProteccionPersonal": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP03_LOTO_RinserLlenadorayCapsulador": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP03_SAM_RinserLlenadorayCapsulador": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_02_EPP_EquipodeProteccionPersonal": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_02_LOTO_Envolvedor": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_02_LOTO_PaletizadoraMagazindePallets": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_02_SAM_Envolvedor": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_02_SAM_PaletizadoraMagazindePallets": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_EPP_EquipodeProteccionPersonal": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_LOTO_MixerRinserLlenadorayCapsulador": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP06_SAM_MixerRinserLlenadorayCapsulador": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP07_EPP_EquipodeProteccionPersonal": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP07_LOTO_LlenadoraySopladora": { intents: 0, corrects: 0, fails: 0, time: 0 },
"LP07_SAM_LlenadoraySopladora": { intents: 0, corrects: 0, fails: 0, time: 0 },
    })
    const [grupsInfo, setgrupsInfo] = useState({});
    const [groupSelected, setGroupSelected] = useState("TODOS");
    const { arrayData } = useSelector(state => state.table);
    const [responseRanking, setResponseRanking] = useState([]);
    const { groups } = useSelector((state) => state.vrlSlice);
    const [datesFilter, setDatesFilter] = useState({
        start: "Wed Jan 01 2025 00:00:00 GMT-0600 (hora estándar central)",
        end: "Tue Apr 08 2026 23:59:59 GMT-0600 (hora estándar central)"
    })

    useEffect(() => {
        const getDataFormated = async () => {
            setdataTratated(baseNamesEstructure)
            let users = 0
            const grups = await onGetAllAlumsByGroups(groups)

            grups.forEach(grup => {
                if (groupSelected === grup.group || groupSelected === "TODOS") {
                    users += grup.students.length
                }
            })

            const filterUniquesUsers = Object.values(
                arrayData.reduce((acc, obj) => {
                    const matricula = obj.matricula;
                    const fechaActual = new Date(obj.Fecha_y_hora);

                    if (!acc[matricula] || new Date(acc[matricula].Fecha_y_hora) < fechaActual) {
                        acc[matricula] = obj;
                    }

                    return acc;
                }, {})
            );


            const filterDateResponse = filterUniquesUsers.filter(item => {
                const itemDate = new Date(item.Fecha_y_hora);
                const startDate = new Date(datesFilter.start);
                const endDate = new Date(datesFilter.end);
                return itemDate >= startDate && itemDate <= endDate;
            });

            const unicsResponses = new Set(filterDateResponse.map(obj => obj.matricula));
            setUsersAndProgress(actual => ({ ...actual, totalUsers: users }));
            setUsersAndProgress(actual => ({ ...actual, activeUsers: unicsResponses.size }));
            setUsersAndProgress(actual => ({ ...actual, inactiveUsers: users - unicsResponses.size }));
            //     console.log(unicsResponses)
            // 
            // promedios
            console.log(filterDateResponse)     
            const dataAnalized =Object.fromEntries(
            Object.entries(baseNamesEstructure).map(([key, value]) => [
                key,
                {
                    ...value,
                    intents: 0,
                    points: 0,
                    fails: 0,
                    time:0,
                },
            ])
        );
            filterDateResponse.forEach(response => {
                for (const key in dataAnalized) {
                        if(  response.responsesOriginal[key]){
                            // console.log(parseInt(response.responsesOriginal[key].time))
                            // console.log(response.responsesOriginal[key])
                            if(response.responsesOriginal[key].time){
                                dataAnalized[key].time+=parseInt(response.responsesOriginal[key].time)
                            }
                            response.responsesOriginal[key].steps.forEach(step => {
                                dataAnalized[key].intents++
                               if(step.isCompleted && step.isCorrectOrder){
                                   dataAnalized[key].points+=2
                               }
                               else if(step.isCompleted || step.isCorrectOrder){
                                   dataAnalized[key].points++
                                   dataAnalized[key].fails++
                                }
                                else{
                                   dataAnalized[key].fails++
                               }
                            })
                        }
            }})
            console.log(dataAnalized)
            setdataTratated(dataAnalized)
        }
        getDataFormated()
    }, [groupSelected, groups, datesFilter,arrayData])

    const getDataPerModules = (modules) => {

        return {
            promedio: 1,
        }
    }

    return (
        <div style={{ background: "rgba(27, 20, 100, 0.1)" }} className='w-full h-screen overflow-scroll'>
            <CustomMainContent>
                <div className="flex w-full min-w-[450px] h-full pr-4">
                    <div className="w-full ">
                        <div className="flex py-3 gap-x-4 pr-6 items-center justify-between">
                            <p className="text-[#686868] text-sm font-semibold font-inter">Usuarios y avance</p>
                            <section className='flex gap-4 text-black'>
                                <DropDownFilterDates
                                    callBack={(start, end, _, { startDate, endDate }, beforeText) => {
                                        setDatesFilter({ start, end })
                                    }}
                                />
                                <Dropdown
                                    className='cursor-pointer'
                                    menu={{
                                        items: groups.map(group => ({ key: group._id, label: group.name })),
                                        onClick: ({ key }) => { console.log(key) }
                                    }}
                                >
                                    <Space>
                                        <p className="text-black "> {groupSelected}</p>
                                        <DownOutlined />
                                    </Space>
                                </Dropdown>
                            </section>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto pb-2 ">
                            {/* <CardNumber newUsers={10} title={"Total de usuarios"} value={usersAndProgress.totalUsers} color="text-[#282828]" /> */}
                            {/*  */}
                            <div className="w-[244px] min-w-[244px] h-[144px] bg-white rounded-2xl shadow-sm p-4">
                                <div className="pt- w-full text-center">
                                    <p className="text-sm text-black leading-5 font-bold">Usuarios totales</p>
                                    <p className='color-[#9a9a9a] text-[10px]'>Total de usuarios registrados</p>
                                    <p className={
                                        `pt-4 leading-5 text-[32px] text-[#282828] font-bold`
                                    }>{  usersAndProgress.totalUsers}</p>
                                </div>
                                {/* <div className="flex justify-between pt-8">
                                    <p className="text-[#9A9A9A] text-[10px]">**</p>
                                    <Tooltip placement="bottom" title={`Periodo anterior: ${0}`}>
                                        <div className={`w-10 h-4 ${true ? "bg-[#55ae7040]" : "bg-[#d9534f40] "}  rounded flex justify-between items-center px-1`}>
                                            <svg className={`w-3 h-3 ${!true && "rotate-180"}`} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                <path d="M7 6H1L3.82353 2L7 6Z" fill={`${true ? "#55AE70" : "#D9534F"}`} />
                                            </svg>
                                            <p className={`text-[10px] text-[${true ? "#55ae70" : "#D9534F"}] font-medium`}>{ }</p>
                                        </div>
                                    </Tooltip>
                                </div> */}
                            </div>
                            {/*  */}
                           <div className="w-[244px] min-w-[244px] h-[144px] bg-white rounded-2xl shadow-sm p-4">
                                <div className="pt- w-full text-center">
                                    <p className="text-sm text-black leading-5 font-bold">Usuarios con avance</p>
                                    <p className='color-[#9a9a9a] text-[10px]'>Usuarios con mínimo 1 desafío completado</p>
                                    <p className={
                                        `pt-4 leading-5 text-[32px] text-[#55AE70] font-bold`
                                    }>{  usersAndProgress.activeUsers}</p>
                                </div>
                                {/* <div className="flex justify-between pt-8">
                                    <p className="text-[#9A9A9A] text-[10px]">**</p>
                                    <Tooltip placement="bottom" title={`Periodo anterior: ${0}`}>
                                        <div className={`w-10 h-4 ${true ? "bg-[#55ae7040]" : "bg-[#d9534f40] "}  rounded flex justify-between items-center px-1`}>
                                            <svg className={`w-3 h-3 ${!true && "rotate-180"}`} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                <path d="M7 6H1L3.82353 2L7 6Z" fill={`${true ? "#55AE70" : "#D9534F"}`} />
                                            </svg>
                                            <p className={`text-[10px] text-[${true ? "#55ae70" : "#D9534F"}] font-medium`}>{ }</p>
                                        </div>
                                    </Tooltip>
                                </div> */}
                            </div> 
                           <div className="w-[244px] min-w-[244px] h-[144px] bg-white rounded-2xl shadow-sm p-4">
                                <div className="pt- w-full text-center">
                                    <p className="text-sm text-black leading-5 font-bold">Usuarios sin cursar</p>
                                    <p className='color-[#9a9a9a] text-[10px]'>Usuarios con mínimo 1 desafío completado</p>
                                    <p className={
                                        `pt-4 leading-5 text-[32px] text-[#ae5555]  font-bold`
                                    }>{  usersAndProgress.inactiveUsers}</p>
                                </div>
                                {/* <div className="flex justify-between pt-8">
                                    <p className="text-[#9A9A9A] text-[10px]">**</p>
                                    <Tooltip placement="bottom" title={`Periodo anterior: ${0}`}>
                                        <div className={`w-10 h-4 ${true ? "bg-[#55ae7040]" : "bg-[#d9534f40] "}  rounded flex justify-between items-center px-1`}>
                                            <svg className={`w-3 h-3 ${!true && "rotate-180"}`} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                <path d="M7 6H1L3.82353 2L7 6Z" fill={`${true ? "#55AE70" : "#D9534F"}`} />
                                            </svg>
                                            <p className={`text-[10px] text-[${true ? "#55ae70" : "#D9534F"}] font-medium`}>{ }</p>
                                        </div>
                                    </Tooltip>
                                </div> */}
                            </div>
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Promedios por Módulos</p>
                            <select 
                            onChange={(e) => setmoduleSelected(actual => parseInt(e.target.value))}
                            className="border border-white text-black font-semibold text-sm px-4 py-1">
                                <option value={1}>LP01</option>
                                <option value={3}>LP03</option>
                                <option value={6}>LP06</option>
                                <option value={62}>LP06_02</option>
                                <option value={7}>LP07</option>
                            </select>
                        </div>
                        <div className="flex  gap-x-4 overflow-y-auto pb-2">
                            <CardProgressParesa 
                                black={true}
                                module={"Curso total"} newUsers={100} title={"Promedio total"}
                                value={(() => { const d = Object.entries(dataTratated).filter(([k]) => k.startsWith('LP')).reduce((a, [, v]) => ({ points: a.points + v.points, intents: a.intents + v.intents, steps: a.steps + v.numberOdSteaps }), { points: 0, intents: 0, steps: 0 }); return Math.round(d.points / (d.intents / d.steps)) })()}
                                maxValue={366} color="text-[#282828]"
                                time={10}
                                repetitions={10}>
                            </CardProgressParesa>
                            {
                                moduleSelected === 1 && 
                                <>
                                <CardProgressParesa module={"Proteccion Personal"} newUsers={100} title={"EPP"}
                                value={
                                    Math.round(
                                        dataTratated["LP01_EPP_EquipodeProteccionPersonal"].points
                                        /
                                        (dataTratated["LP01_EPP_EquipodeProteccionPersonal"].intents / dataTratated["LP01_EPP_EquipodeProteccionPersonal"].numberOdSteaps)
                                    )
                                }
                                        maxValue={14} color="text-[#282828]"
                                time={ dataTratated["LP01_EPP_EquipodeProteccionPersonal"].time / dataTratated["LP01_EPP_EquipodeProteccionPersonal"].intents}
                                repetitions={
                                     dataTratated["LP01_EPP_EquipodeProteccionPersonal"].fails / dataTratated["LP01_EPP_EquipodeProteccionPersonal"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Despaletizadora"} newUsers={100} title={"LOTO"}
                                value={
                                    Math.round(
                                        dataTratated["LP01_LOTO_Despaletizadora"].points /
                                        (dataTratated["LP01_LOTO_Despaletizadora"].intents / dataTratated["LP01_LOTO_Despaletizadora"].numberOdSteaps)
                                    )
                                }
                                maxValue={22} color="text-[#282828]"
                                time={dataTratated["LP01_LOTO_Despaletizadora"].time / dataTratated["LP01_LOTO_Despaletizadora"].intents}
                                repetitions={
                                     dataTratated["LP01_LOTO_Despaletizadora"].fails / dataTratated["LP01_LOTO_Despaletizadora"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Paletizadora"} newUsers={100} title={"LOTO"}
                               value={
                                   Math.round(
                                       dataTratated["LP01_LOTO_Paletizadora"].points /
                                       (dataTratated["LP01_LOTO_Paletizadora"].intents / dataTratated["LP01_LOTO_Paletizadora"].numberOdSteaps)
                                   )
                                }
                                maxValue={22} color="text-[#282828]"
                                time={  dataTratated["LP01_LOTO_Paletizadora"].time / dataTratated["LP01_LOTO_Paletizadora"].intents}
                                repetitions={
                                     dataTratated["LP01_LOTO_Paletizadora"].fails / dataTratated["LP01_LOTO_Paletizadora"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Paletizadora y Despaletizadora"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(
                                       dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].points /
                                       (dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].intents / dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].numberOdSteaps)
                                   )
                                }
                                maxValue={12} color="text-[#282828]"
                                time={ dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].time / dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].intents}
                                repetitions={
                                     dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].fails / dataTratated["LP01_SAM_PaletizadorayDespaletizadora"].intents
                                }>
                            </CardProgressParesa>
                                </>
                            }
                            {
                                moduleSelected === 3 && 
                                <>
                                <CardProgressParesa module={"Proteccion Personal"} newUsers={100} title={"EPP"}
                                value={
                                    Math.round(dataTratated["LP03_EPP_EquipodeProteccionPersonal"].points /
                                        (dataTratated["LP03_EPP_EquipodeProteccionPersonal"].intents / dataTratated["LP03_EPP_EquipodeProteccionPersonal"].numberOdSteaps))
                                }
                                        maxValue={14} color="text-[#282828]"
                                time={ dataTratated["LP03_EPP_EquipodeProteccionPersonal"].time / dataTratated["LP03_EPP_EquipodeProteccionPersonal"].intents}
                                repetitions={
                                     dataTratated["LP03_EPP_EquipodeProteccionPersonal"].fails / dataTratated["LP03_EPP_EquipodeProteccionPersonal"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Envolvedor"} newUsers={100} title={"LOTO"}
                                value={
                                    Math.round(dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].points /
                                        (dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].intents / dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].numberOdSteaps))
                                }
                                maxValue={24} color="text-[#282828]"
                                time={dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].time / dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].intents}
                                repetitions={
                                     dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].fails / dataTratated["LP03_LOTO_RinserLlenadorayCapsulador"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Paletizadora Magazinde Pallets"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].points /
                                       (dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].intents / dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].numberOdSteaps))
                                }
                                maxValue={12} color="text-[#282828]"
                                time={ dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].time / dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].intents}
                                repetitions={
                                     dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].fails / dataTratated["LP03_SAM_RinserLlenadorayCapsulador"].intents
                                }>
                            </CardProgressParesa>
                                </>
                            }
                            {
                                moduleSelected === 6 && 
                                <div className='flex  w-[820px] gap-x-4 overflow-x-auto'>
                                
                                <CardProgressParesa module={"Proteccion Personal"} newUsers={100} title={"EPP"}
                               value={
                                   Math.round(dataTratated["LP06_EPP_EquipodeProteccionPersonal"].points /
                                       (dataTratated["LP06_EPP_EquipodeProteccionPersonal"].intents / dataTratated["LP06_EPP_EquipodeProteccionPersonal"].numberOdSteaps)
                                   )
                                }
                                            maxValue={14} color="text-[#282828]"
                                time={dataTratated["LP06_EPP_EquipodeProteccionPersonal"].time / dataTratated["LP06_EPP_EquipodeProteccionPersonal"].intents}
                                repetitions={
                                     dataTratated["LP06_EPP_EquipodeProteccionPersonal"].fails / dataTratated["LP06_EPP_EquipodeProteccionPersonal"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Mixer Rinser Llenadora y Capsulador"} newUsers={100} title={"LOTO"}
                               value={
                                   Math.round(dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].points /
                                       (dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].intents / dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].numberOdSteaps)
                                   )
                                }
                                maxValue={48} color="text-[#282828]"
                                time={dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].time / dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].intents}
                                repetitions={
                                     dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].fails / dataTratated["LP06_LOTO_MixerRinserLlenadorayCapsulador"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Mixer Rinser Llenadora y Capsulador"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].points /
                                       (dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].intents / dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].numberOdSteaps)
                                   )
                                }
                                maxValue={18} color="text-[#282828]"
                                time={dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].time / dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].intents}
                                repetitions={
                                     dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].fails / dataTratated["LP06_SAM_MixerRinserLlenadorayCapsulador"].intents
                                }>
                            </CardProgressParesa>
                                </div>
                            }
                            {
                                moduleSelected === 62 &&
                                   <div className='flex  w-[820px] gap-x-4 overflow-x-auto'>
                                <CardProgressParesa module={"Proteccion Personal"} newUsers={100} title={"EPP"}
                                value={
                                    Math.round(dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].points /
                                        (dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].intents / dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].numberOdSteaps)
                                    )
                                }
                                            maxValue={14} color="text-[#282828]"
                                time={ dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].time / dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].intents}
                                repetitions={
                                     dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].fails / dataTratated["LP06_02_EPP_EquipodeProteccionPersonal"].intents
                                }>
                            </CardProgressParesa>
                            <CardProgressParesa module={"Envolvedor"} newUsers={100} title={"LOTO"}
                                value={
                                    Math.round(dataTratated["LP06_02_LOTO_Envolvedor"].points /
                                        (dataTratated["LP06_02_LOTO_Envolvedor"].intents / dataTratated["LP06_02_LOTO_Envolvedor"].numberOdSteaps)
                                    )
                                }
                                maxValue={32} color="text-[#282828]"
                                time={ dataTratated["LP06_02_LOTO_Envolvedor"].time / dataTratated["LP06_02_LOTO_Envolvedor"].intents}
                                repetitions={
                                     dataTratated["LP06_02_LOTO_Envolvedor"].fails / dataTratated["LP06_02_LOTO_Envolvedor"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Paletizadora Magazinde Pallets"} newUsers={100} title={"LOTO"}
                               value={
                                   Math.round(dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].points /
                                       (dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].intents / dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].numberOdSteaps)
                                   )
                                }
                                maxValue={24} color="text-[#282828]"
                                time={dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].time / dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].intents}
                                repetitions={
                                     dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].fails / dataTratated["LP06_02_LOTO_PaletizadoraMagazindePallets"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Envolvedor"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(dataTratated["LP06_02_SAM_Envolvedor"].points /
                                       (dataTratated["LP06_02_SAM_Envolvedor"].intents / dataTratated["LP06_02_SAM_Envolvedor"].numberOdSteaps)
                                   )
                                }
                                maxValue={24} color="text-[#282828]"
                                time={ dataTratated["LP06_02_SAM_Envolvedor"].time / dataTratated["LP06_02_SAM_Envolvedor"].intents}
                                repetitions={
                                     dataTratated["LP06_02_SAM_Envolvedor"].fails / dataTratated["LP06_02_SAM_Envolvedor"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Paletizadora Magazinde Pallets"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].points /
                                       (dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].intents / dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].numberOdSteaps)
                                   )
                                }
                                maxValue={14} color="text-[#282828]"
                                time={dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].time / dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].intents}
                                repetitions={
                                     dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].fails / dataTratated["LP06_02_SAM_PaletizadoraMagazindePallets"].intents
                                }>
                            </CardProgressParesa>
                                </div>
                            }
                             {
                                moduleSelected === 7 && 
                                <>
                                <CardProgressParesa module={"Proteccion Personal"} newUsers={100} title={"EPP"}
                                value={
                                    Math.round(dataTratated["LP07_EPP_EquipodeProteccionPersonal"].points /
                                        (dataTratated["LP07_EPP_EquipodeProteccionPersonal"].intents / dataTratated["LP07_EPP_EquipodeProteccionPersonal"].numberOdSteaps)
                                    )
                                }
                                        maxValue={14} color="text-[#282828]"
                                time={  dataTratated["LP07_EPP_EquipodeProteccionPersonal"].time / dataTratated["LP07_EPP_EquipodeProteccionPersonal"].intents}
                                repetitions={
                                     dataTratated["LP07_EPP_EquipodeProteccionPersonal"].fails / dataTratated["LP07_EPP_EquipodeProteccionPersonal"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Llen y Sopl"} newUsers={100} title={"LOTO"}
                                value={
                                    Math.round(dataTratated["LP07_LOTO_LlenadoraySopladora"].points /
                                        (dataTratated["LP07_LOTO_LlenadoraySopladora"].intents / dataTratated["LP07_LOTO_LlenadoraySopladora"].numberOdSteaps)
                                    )
                                }
                                maxValue={24} color="text-[#282828]"
                                time={ dataTratated["LP07_LOTO_LlenadoraySopladora"].time / dataTratated["LP07_LOTO_LlenadoraySopladora"].intents}
                                repetitions={
                                     dataTratated["LP07_LOTO_LlenadoraySopladora"].fails / dataTratated["LP07_LOTO_LlenadoraySopladora"].intents
                                }>
                            </CardProgressParesa>
                                <CardProgressParesa module={"Llen y Sopl"} newUsers={100} title={"SAM"}
                               value={
                                   Math.round(dataTratated["LP07_SAM_LlenadoraySopladora"].points /
                                       (dataTratated["LP07_SAM_LlenadoraySopladora"].intents / dataTratated["LP07_SAM_LlenadoraySopladora"].numberOdSteaps)
                                   )
                                }
                                maxValue={20} color="text-[#282828]"
                                time={ dataTratated["LP07_SAM_LlenadoraySopladora"].time / dataTratated["LP07_SAM_LlenadoraySopladora"].intents}
                                repetitions={
                                     dataTratated["LP07_SAM_LlenadoraySopladora"].fails / dataTratated["LP07_SAM_LlenadoraySopladora"].intents
                                }>
                            </CardProgressParesa>
                                </>
                            }

                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Datos analíticos</p>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto overflow-y-hidden">
                            <Meanings
                                meanings={[ 
                                    ['LP01_EPP_EquipodeProteccionPersonal: ', ''],
                                    ['LP01_LOTO_Despaletizadora: ', ''],
                                    ['LP01_LOTO_Paletizadora: ', ''],
                                    ['LP01_SAM_PaletizadorayDespaletizadora: ', ''],
                                    ['LP03_EPP_EquipodeProteccionPersonal: ', ''],
                                    ['LP03_LOTO_RinserLlenadorayCapsulador: ', ''],
                                    ['LP03_SAM_RinserLlenadorayCapsulador: ', ''],
                                    ['LP06_02_EPP_EquipodeProteccionPersonal: ', ''],
                                    ['LP06_02_LOTO_Envolvedor: ', ''],
                                    ['LP06_02_LOTO_PaletizadoraMagazindePallets: ', ''],
                                    ['LP06_02_SAM_Envolvedor: ', ''],
                                    ['LP06_02_SAM_PaletizadoraMagazindePallets: ', ''],
                                    ['LP06_EPP_EquipodeProteccionPersonal: ', ''],
                                    ['LP06_LOTO_MixerRinserLlenadorayCapsulador: ', ''],
                                    ['LP06_SAM_MixerRinserLlenadorayCapsulador: ', ''],
                                    ['LP07_EPP_EquipodeProteccionPersonal: ', ''],
                                    ['LP07_LOTO_LlenadoraySopladora: ', ''],
                                    ['LP07_SAM_LlenadoraySopladora: ', ''],
                                ]}
                            />
                            <CarBarCharParesa
                                usersEnd={dataTratated}
                                title={"Tiempo promedio por tarea"}
                                info={dataTratated} ></CarBarCharParesa>
                            <CarBarCharParesa
                                usersEnd={dataTratated}
                                type={"unique"}
                                title={"Número promedio de errores por tarea"}
                                info={dataTratated} ></CarBarCharParesa>

                        </div>
                        <div className="py-6 flex gap-x-4">
                            {/* <RankingSimiAR users={responseRanking} /> */}
                            {/* <CardBarRadarSimiAR info={grupsInfo}></CardBarRadarSimiAR> */}

                        </div>
                    </div>
                </div>
            </CustomMainContent>
        </div>
    )
}
